import React, { useEffect, useState } from "react";

const numberToWords = (num) => {
  const belowTwenty = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const aboveThousand = ["Thousand", "Million", "Billion", "Trillion"];

  if (num < 20) return belowTwenty[num];
  if (num < 100)
    return (
      tens[Math.floor(num / 10)] +
      (num % 10 === 0 ? "" : " " + belowTwenty[num % 10])
    );
  if (num < 1000)
    return (
      belowTwenty[Math.floor(num / 100)] +
      " Hundred" +
      (num % 100 === 0 ? "" : " " + numberToWords(num % 100))
    );

  for (let i = 0; i < aboveThousand.length; i++) {
    const unit = Math.pow(1000, i + 1);
    if (num < unit * 1000) {
      return (
        numberToWords(Math.floor(num / unit)) +
        " " +
        aboveThousand[i] +
        (num % unit === 0 ? "" : " " + numberToWords(num % unit))
      );
    }
  }
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const PrintComponent = ({ formData }) => {
  const [grp, setGrp] = useState("85px"); //For Height
  const [lGrp, setLGrp] = useState("110px"); //For left group name postion
  const [rGrp, setRGrp] = useState("160px"); // For right group name position
  const [ldetails, setLDetails] = useState("60px"); //left side details position
  const [rdetails, setRDetails] = useState("42px"); // right side details position

  useEffect(() => {
    if (!formData) return;
    const amount = parseFloat(formData.amount).toFixed(2);
    const amountInWords = numberToWords(parseInt(formData.amount, 10));
    const formattedDate = formatDate(formData.transaction_at);
    // console.log(formData);
    const content = ` <html>
    <head>
    <title>Transaction Details</title>
    <style>
      body{
      
      margin: 0px;
      padding: 0px;
       font-family:  'Courier New", Courier, "Lucida Console", "OCR-A", Monaco, monospace;
       font-size: 14px;
      }

        @page {
          size: 960px 283.46456693px;
          margin: 0px;
          padding: 0px;
        }
        .print-container {
         width: 960px;
         height:  284px;
         position: relative;

        }
        .left-section {

         width: 385.51181102px;
         height: 283.46456693px;
         position: absolute;
         top: 0;
         left: 0;
        }

        .lgroup-name {
          position: absolute;
          top: 76px;
          left: 115px;
        }
        .lsubscription-number {
          position: absolute;
          top: 116px;
          left: 60px;
        }
       .luser-name {
          position: absolute;
          top: 147px;
          left: 60px;
        }
        .lamount-in-words {
           position: absolute;
           top: 178px;
           left: 60px;
        }
        .lamount {
          position: absolute;
          top: 214px;
          left: 60px;
        }
        .ltransaction-date {
          position: absolute;
          top: 116px;
          left: 205px;
        }

        .lvoucher {
          position: absolute;
          top: 128px;
          left: 205px;
        }


        .right-section {

          width: 574.48818898px;
          height: 283.46456693px;
          position: absolute;
          top: 0;
          right: 0;
        }
        .rgroup-name {
          position: absolute;
          top: 76px;
          left: 170px;
        }
        .rsubscription-number {
          position: absolute;
          top: 116px;
            left: 43px;
        }
       .ruser-name {
          position: absolute;
          top: 147px;
            left: 43px;
        }
        .ramount-in-words {
           position: absolute;
           top: 177px;
           left: 43px;
        }
        .ramount {
          position: absolute;
          top: 207px;
          left: 43px;
        }
        .rtransaction-date {
          position: absolute;
          top: 117px;
           right: 175px;
        }

        .rvoucher{
        position: absolute;
          top: 130px;
           right: 176px;
        }
        @media print{
                    page-break-after: always;
                     background: red;
          }
          .print-container {
           width: 960px;
           height: 283.46456693px;


          }
        }
    </style>
  </head>
     <body>
        <div class="print-container">
          <div class="left-section section-content">
            <p class="lgroup-name">${formData.group_title}</p>
            <p class="lsubscription-number">${formData.subscription_no}</p>
            <p class="luser-name">${formData.user_full_name}</p>
            <p class="lamount-in-words">${amountInWords} Only</p>
            <p class="lamount">${amount}</p>
           <p class="ltransaction-date">${formattedDate}</p>
            <p class="lvoucher">Vo:${formData.voucher}</p>

          </div>
          <div class="right-section section-content">
            <p class="rgroup-name">${formData.group_title}</p>
            <p class="rsubscription-number">${formData.subscription_no}</p>
             <p class="ruser-name">${formData.user_full_name}</p>
            <p class="ramount-in-words">${amountInWords} Only</p>
            <p class="ramount">${amount}</p>
            <p class="rtransaction-date">${formattedDate}</p>
             <p class="rvoucher">Vo:${formData.voucher}</p>
           
          </div>
       <script>
          // Wait for content to load, then print immediately
          window.onload = function() {
            if (navigator.onLine) {
              setTimeout(function() {
                window.print();
              }, 0); // Print after a very short delay
            }
          }
        </script>
        </div>
      </body>
    </html>`;

    //Create a new document with the content
    const printDocument = document.createElement("iframe");
    printDocument.style.position = "absolute";
    printDocument.style.width = "0px";
    printDocument.style.height = "0px";
    printDocument.style.border = "none";
    document.body.appendChild(printDocument);
    printDocument.contentWindow.document.open();
    printDocument.contentWindow.document.write(content);
    printDocument.contentWindow.document.close();
    printDocument.contentWindow.close();
    setTimeout(() => {
      document.body.removeChild(printDocument);
    }, 1000);
  }, [formData]);

  return null;
};

export default PrintComponent;
